// src/context/LanguageContext.jsx
"use client";
import { createContext, useContext, useState, useEffect } from "react";

// Create and export the context directly
export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en");

  const toggleLanguage = () => {
    setLanguage((prev) => {
      const newLang = prev === "en" ? "ar" : "en";
      document.documentElement.lang = newLang;
      // document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
      if (typeof window !== "undefined") {
        localStorage.setItem("ulc-lang", newLang);
      }
      return newLang;
    });
  };

  useEffect(() => {
    // Initialize from localStorage if available
    if (typeof window !== "undefined") {
      const savedLang = localStorage.getItem("ulc-lang");
      if (savedLang) {
        setLanguage(savedLang);
      }
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
